import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import consola from 'consola';
import productQuery from '~/graphql/product.gql';
import productVariantsQuery from '~/graphql/product/variants.gql';
import productImagesQuery from '~/graphql/product/images.gql';
import productCarouselsQuery from '~/graphql/product-carousels.gql';

function fetchProductNav(_x, _x2) {
  return _fetchProductNav.apply(this, arguments);
}

function _fetchProductNav() {
  _fetchProductNav = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, reference) {
    var locale, xhrUri, _ref3, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "/nav/nav-api/product/".concat(locale.market, "/").concat(locale.language, "/p/slug-").concat(reference, ".htm");
            _context.prev = 2;
            _context.next = 5;
            return context.$axios.get(xhrUri);

          case 5:
            _ref3 = _context.sent;
            data = _ref3.data;
            return _context.abrupt("return", data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            consola.error(_context.t0);
            return _context.abrupt("return", null);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _fetchProductNav.apply(this, arguments);
}

function fetchProductCarousels(_x3, _x4) {
  return _fetchProductCarousels.apply(this, arguments);
}

function _fetchProductCarousels() {
  _fetchProductCarousels = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context, reference) {
    var profileId,
        exclude,
        locale,
        withBrand,
        _ref4,
        data,
        _args2 = arguments;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            profileId = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
            exclude = _args2.length > 3 ? _args2[3] : undefined;
            locale = context.state.i18n.currentLocale.iso;
            withBrand = process.client && context.$cookies.get('product-brand') === 1;
            _context2.prev = 4;
            _context2.next = 7;
            return context.app.apolloProvider.defaultClient.query({
              query: productCarouselsQuery,
              variables: {
                profileId: profileId,
                reference: reference,
                locale: locale,
                exclude: exclude,
                withBrand: withBrand
              }
            });

          case 7:
            _ref4 = _context2.sent;
            data = _ref4.data;
            return _context2.abrupt("return", data.product);

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](4);
            consola.error(_context2.t0);
            return _context2.abrupt("return", null);

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 12]]);
  }));
  return _fetchProductCarousels.apply(this, arguments);
}

function fetchProduct(_x5, _x6) {
  return _fetchProduct.apply(this, arguments);
}

function _fetchProduct() {
  _fetchProduct = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context, reference) {
    var profileId,
        locale,
        withBrand,
        _ref5,
        data,
        _args3 = arguments;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            profileId = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : null;
            locale = context.state.i18n.currentLocale.iso;
            withBrand = process.client && context.$cookies.get('product-brand') === 1;
            _context3.prev = 3;
            _context3.next = 6;
            return context.app.apolloProvider.defaultClient.query({
              query: productQuery,
              variables: {
                profileId: profileId,
                reference: reference,
                locale: locale,
                withBrand: withBrand
              }
            });

          case 6:
            _ref5 = _context3.sent;
            data = _ref5.data;
            return _context3.abrupt("return", data.product);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](3);
            consola.error(_context3.t0);
            return _context3.abrupt("return", null);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 11]]);
  }));
  return _fetchProduct.apply(this, arguments);
}

function fetchProductVariants(_x7, _x8) {
  return _fetchProductVariants.apply(this, arguments);
}

function _fetchProductVariants() {
  _fetchProductVariants = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(_ref, reference) {
    var app, getters, locale, _ref6, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            app = _ref.app, getters = _ref.getters;
            locale = getters['i18n/locale'].iso;
            _context4.prev = 2;
            _context4.next = 5;
            return app.apolloProvider.defaultClient.query({
              query: productVariantsQuery,
              variables: {
                reference: reference,
                locale: locale
              }
            });

          case 5:
            _ref6 = _context4.sent;
            data = _ref6.data;
            return _context4.abrupt("return", data.product);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](2);
            consola.error(_context4.t0);
            return _context4.abrupt("return", null);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 10]]);
  }));
  return _fetchProductVariants.apply(this, arguments);
}

function fetchProductImages(_x9, _x10) {
  return _fetchProductImages.apply(this, arguments);
}

function _fetchProductImages() {
  _fetchProductImages = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(_ref2, reference) {
    var app, getters, locale, _ref7, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            app = _ref2.app, getters = _ref2.getters;
            locale = getters['i18n/locale'].iso;
            _context5.prev = 2;
            _context5.next = 5;
            return app.apolloProvider.defaultClient.query({
              query: productImagesQuery,
              variables: {
                reference: reference,
                locale: locale
              }
            });

          case 5:
            _ref7 = _context5.sent;
            data = _ref7.data;
            return _context5.abrupt("return", data.product);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            consola.error(_context5.t0);
            return _context5.abrupt("return", null);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 10]]);
  }));
  return _fetchProductImages.apply(this, arguments);
}

export { fetchProduct, fetchProductCarousels, fetchProductVariants, fetchProductImages, fetchProductNav };